import {
  ADVANCE_SEARCH_DATA_REQUEST,
  ADVANCE_SEARCH_DATA_SUCCESS,
  ADVANCE_SEARCH_DATA_LOADING,
  ADVANCE_SEARCH_DATA_FAILURE,
} from '../../actions/actionTypes';

interface AdvanceSearchState {
  advanceSearchData : any[];
  advanceSearchLoading: boolean;
}


const initialState : AdvanceSearchState= {
  advanceSearchData: [],
  advanceSearchLoading: false,
}


export default function AdvanceSearchReducer(
  state: AdvanceSearchState = initialState,
  action: { type: string; payload?: any }
) {
  switch (action.type) {
    case ADVANCE_SEARCH_DATA_SUCCESS:
      return {
        ...state,
        advanceSearchData: action.payload,
        advanceSearchLoading: false,
      }

    case ADVANCE_SEARCH_DATA_LOADING:
      return {
        ...state,
        advanceSearchLoading: action.payload,
      }

    case ADVANCE_SEARCH_DATA_FAILURE:
      return {
        ...state,
        advanceSearchData: [],
        advanceSearchLoading: false,
      }

    default:
      return state;
  }
}

